import { render, staticRenderFns } from "./CancellationEmbedCode.vue?vue&type=template&id=7460787e&"
import script from "./CancellationEmbedCode.vue?vue&type=script&lang=js&"
export * from "./CancellationEmbedCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports